import { getStore } from '@/store/index';
import SelectItem from '@/common/interfaces/SelectItem';
import Address, { names, AddressFieldType } from '@/common/interfaces/dto/Address';
import { getCountryData, CountryFullData } from '@/api/CountryStateApi';

import {
  validate,
  getInfoByZipCode,
  StreetAutocompleteParams,
  getAddressSuggestions,
} from './AddressRow.api';

import { Country } from '@/store/modules/metadataModule';

let country = getStore().state.Meta.Country;

let data: CountryFullData = getCountryData();

const UsId = 385;
const AusId = 211;
const CanadaId = 400;
const UkId = 384;

export const isUs = (countryId: number) => countryId === UsId;
export const isCanada = (countryId: number) => countryId === CanadaId;
export const isStateCountries = (countryId: number) =>
  data.States.map((s) => s.CountryId).includes(+countryId);

export const changeModelByCountryId = (
  input: (field: AddressFieldType, value: any) => void,
  countryId: number,
  init: boolean = false,
) => {
  input(names.CountryId, countryId);

  if (!init) {
    clearChangingFields(input);
  }
};

export const clearChangingFields = (input: (field: AddressFieldType, value: any) => void) => {
  input(names.PostalCode, '');
  input(names.StateCode, '');
};

export const getAddressAutocompleteSuggestions = async (params: StreetAutocompleteParams) => {
  const result = await getAddressSuggestions(params, {
    showLoading: false,
    cacheResults: true,
  });

  if (result.IsOk) {
    return result.Item;
  }

  return [];
};

export const getInitCountryValue = () => {
  switch (country) {
    case Country.AUS:
      return AusId;
    case Country.UK:
      return UkId;
    default:
      return UsId;
  }
};

export const getCountries = (isBrochure: boolean): SelectItem[] => {
  let primeCountries: string[] = [];
  switch (country) {
    case Country.AUS:
      primeCountries = ['Australia', 'New Zealand']; break
    case Country.UK:
      primeCountries = ['United Kingdom']; break
    default:
      primeCountries = ['United States', 'Canada'];
  }

  const countries = data.Countries.filter((c) => c.IsForBrochures || !isBrochure).map(
    (c) =>
      ({
        Value: c.Value,
        Text: c.Text,
        data: c,
      } as SelectItem),
  );

  const blankLine = {
    Value: -1,
    Text: '',
    Disabled: true,
    data: {},
  } as SelectItem;

  return [
    ...(primeCountries
      .map((name) => ({ ...countries.find((c) => name === c.Text) } as SelectItem))
      .map((p) => ({ ...p, Value: p.Value, Prime: true })) // fix vue-select duplicates
      .filter((c) => c) as SelectItem[]),
    blankLine,
    ...countries,
  ];
};

export const getStates = (countryId: number) => {
  let states: string[] = data.States.find((s) => s.CountryId === +countryId)?.States || [];

  return states.map((s) => ({ Text: s, Value: s }));
};

export const getPhoneCode = (countryId?: number) => {
  if (countryId === undefined) {
    countryId = getInitCountryValue();
  }

  const country = data.Countries.find((c) => c.Value === countryId);

  return country ? country.PhoneCode : '+1';
};

export const isShow = (field: AddressFieldType, countryId: number) => {
  switch (field) {
    case names.StateCode:
      return isStateCountries(+countryId);
    case names.PostalCode:
      return !isUs(countryId);
    default:
      return true;
  }
};

export const getCountryName = (countryId: number) => {
  const country = data.Countries.find((c) => c.Value === countryId);

  return country ? country.Text : '';
};

export const validateFullAddress = async (model: Address) => {
  const result = await validate(model, { showLoading: false, cacheResults: true });

  return result;
};
